// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeaturedCourseCard_wrapper__LqkFQ","card-img":"FeaturedCourseCard_card-img__0IIA6","card-content":"FeaturedCourseCard_card-content__snjxt"};